import { Media } from '@atom/types/media';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';

import classes from './workOrderDetailPdfReport.module.css';

interface Props {
  image: Media;
  imageWidth: string;
  imageHeight: string;
  loading: (loading: boolean) => void;
}

const MainPhotoTile = ({ image, imageWidth, imageHeight, loading }: Props) => {
  return (
    <div
      style={{
        width: imageWidth,
        height: imageHeight,
        backgroundImage: `url('${FILES_ENDPOINT}/${image.fileId}_1440')`,
      }}
      className={classes.mainPhotoContainer}
      onLoad={() => loading(false)}
    />
  );
};

export default MainPhotoTile;
